import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TrackJsService } from './track-js.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoopbackValidationError } from '../api';

@Injectable({providedIn: "root"})
export class ErrorService {

  constructor(
    private trackJS: TrackJsService,
    private router: Router
  ) { }

  latestErrors: any[]  = []

  error(userMessage: string, err: any, messageService: MessageService, technicalMessage?: string) {
    
    this.trackJS.track({technicalMessage: technicalMessage, error:err})
    let validationErrors = ""
    if (err?.error?.error?.code === "VALIDATION_FAILED") {
      const valError = err.error as LoopbackValidationError

      validationErrors = valError.error.details.map(e => ` ${e.path} ${e.message} ${JSON.stringify(e?.info)}`).join("\n")
      

    }

    let errorMessage = ""

    if (err?.error?.message) {
      errorMessage = err?.error?.message + "\n"
    }

    if (err?.error?.error?.message) {
      errorMessage = err?.error?.error?.message + "\n"
    }

    messageService.add({severity: "error", summary: userMessage, detail: `${errorMessage}\n${validationErrors}`,closable: true, life: 30000})
    this.latestErrors.unshift({route: this.router.routerState.snapshot.url, error: err, technicalMessage: technicalMessage, userMessage: userMessage})
    if (this.latestErrors.length > 10) {
      this.latestErrors = this.latestErrors.slice(0, 5)
    }
  }

  
}
